import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ArticleCta() {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-br from-emerald-600 to-emerald-700">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/15 text-white">
            <i className="ri-file-text-line w-6 h-6 flex items-center justify-center" aria-hidden="true" />
          </span>
          <h2 className="mt-5 text-2xl font-bold text-white md:text-3xl">{t('articleCta.title')}</h2>
          <p className="mt-3 text-sm text-emerald-50 md:text-base">{t('articleCta.subtitle')}</p>
          <Link
            to="/usfans-spreadsheet-guide"
            className="mt-7 inline-flex items-center justify-center gap-2 rounded-md bg-white px-6 py-3 text-sm font-semibold text-emerald-700 hover:bg-emerald-50 whitespace-nowrap cursor-pointer"
          >
            {t('articleCta.button')}
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}